/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameAssets} from "../ThorGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";

export class ThorIntroView extends StillImageBgIntroView {

    //private _text:PIXI.Text;
    private _logo:PIXI.Sprite;
    private _gfxContainer:PIXI.Container;
    private _thorFeature:PIXI.Sprite;
    private _otherFeatures:PIXI.Container;

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();
        this._logo = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);


        this._thorFeature = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_THOR_FEATURE)[0]);
        this._thorFeature.anchor.set(0.5, 0.5);

        const asgardBanner = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_BANNER_ASGARD_SPINS)[0]);
        const hammerTimeBanner = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_BANNER_HAMMER_TIME)[0]);
        const runeRazeBanner = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_BANNER_RUNE_RAZE)[0]);

        asgardBanner.position.set(0, 0);
        hammerTimeBanner.position.set(0, 85);
        runeRazeBanner.position.set(0, 190);

        this._otherFeatures = new PIXI.Container();
        this._otherFeatures.addChild(asgardBanner);
        this._otherFeatures.addChild(hammerTimeBanner);
        this._otherFeatures.addChild(runeRazeBanner);
        this._otherFeatures.pivot.set(this._otherFeatures.width * 0.5, this._otherFeatures.height * 0.5);


        this._gfxContainer.addChild(this._logo);
        this._gfxContainer.addChild(this._thorFeature);
        this._gfxContainer.addChild(this._otherFeatures);


        const colorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
        colorMatrixFilter.saturate(-0.5, false);
        this._background.filters = [colorMatrixFilter];


        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {

        if(resizeData.orientation == Orientation.PORTRAIT) {

            this._logo.scale.set(1, 1);

            this._logo.position.set(0, -560);
            this._thorFeature.position.set(0, -150);
            this._otherFeatures.position.set(0, 170);

            this._gfxContainer.scale.set(1);

            const frame:PIXI.Rectangle = new PIXI.Rectangle(
                0,
                0,
                this._screenWidth * 0.8,
                this._screenHeight * 0.7
            );

            const scale = Math.min(frame.width / this._gfxContainer.width, frame.height / this._gfxContainer.height);
            this._gfxContainer.scale.set(scale);

        } else {
            this._gfxContainer.scale.set(1);
            this._logo.scale.set(0.7, 0.7);


            this._logo.position.set(0, -320);
            this._thorFeature.position.set(-280, 0);
            this._otherFeatures.position.set(280, 20);

        }

        this._gfxContainer.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
    }


    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(() => {
            this._background.filters = [];
            if(closeCallback) {
                closeCallback();
            }
        });
    }
}